import { configs } from '$configs';
import { SORT, COLORS, DATE_FORMATS } from '$gbusiness/enums';
import CellModel from '$gbusiness/models/cell';
import { Button } from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { formatDatetime, timestamp } from '$gbusiness/helpers/date';
import { defaultDataSource, defaultStyles, TableModel } from '$gbusiness/models/table';
import { deriveRawToDepartment } from '$fbusiness/models/department';
import Img from '$gcomponents/primitives/img';
import PATH from '$business/enums/paths';
import { getInitial } from '$gbusiness/helpers/util';

export const DEPTS_TABLE_CONFIG: TableModel = {
  dataSource: {
    ...defaultDataSource,
    endpoint: configs.api.department.general,
    deriveToModel: deriveRawToDepartment,
    method: 'GET',
    defaultSortKey: 'updatedAt',
    defaultSortOrder: SORT.DSC,
    shouldVirtualize: false,
    pageSize: 20,
  },
  styles: {
    ...defaultStyles,
    color: COLORS.LIGHT,
    fontSize: '1.05em',
    responsive: true,
    minWidth: 500,
    maxWidth: 800,
    cellPadding: ` 8px 4px`,
    borderColor: 'var(--ion-border-color)',
    isStripped: false,
    disableSort: true,
  },
  filter: {
    color: COLORS.PRIMARY,
  },
};

export const DEPTS_TABLE = (settings: any): Array<CellModel> => [
  {
    label: 'SCREEN.DEPARTMENTS.COLS.PHOTO',
    value: 'factoryId',
    align: 'center',
    className: 'image',
    component: (row) => (
      <Img
        src={row.image}
        cache={timestamp(row.updatedAt)}
        height="64px"
        width="64px"
        placeholder="No Image"
        initial={settings?.imageInitial ? getInitial(row.name) : undefined}
      />
    ),
    alwaysShow: true,
    width: 120,
  },
  {
    label: 'SCREEN.DEPARTMENTS.COLS.NAME',
    value: 'name',
    className: 'main',
    alwaysShow: true,
    width: 300,
  },
  {
    label: 'SCREEN.DEPARTMENTS.COLS.UPDATED',
    value: 'updatedAt',
    className: 'desktop',
    component: (row) => <>{row.updatedAt ? formatDatetime(row.updatedAt, DATE_FORMATS.DATETIME) : ''}</>,
    sortable: SORT.ASC,
    width: 200,
  },
  {
    label: 'SCREEN.DEPARTMENTS.COLS.ACTION',
    value: '',
    align: 'center',
    className: 'action',
    component: (row, actions) => {
      return (
        <Button
          className="left"
          fullWidth
          onClick={(e) => actions.handlePopoverOpen(e, { ...row, route: PATH.DEPARTMENTS })}>
          <MoreHorizIcon />
        </Button>
      );
    },
    width: 80,
  },
];
